module.exports = __webpack_public_path__ + "assets/img/ic-left-arrow37957ef6.svg";